// Shared backend→frontend message mapper.
//
// Extracted from useChatSession so the insights chat (ChatPage/useChatSession)
// and the global platform assistant (AssistantDrawer) map conversation history
// through the SAME code — no subtly divergent copies (plan 2026-07-28 §4/3.1).
import type { MessageType } from "@/pages/ChatPage";
import { formatMessageDate } from "@/utils/formatMessageDate";

export const mapBackendMessageToFrontend = (m: any): MessageType => ({
  id: m.id,
  sender: m.sender,
  content: m.content,
  timestamp: formatMessageDate(new Date(m.timestamp)),
  firstName: m.first_name,
  chartData: m.chart_data,
  tableData: m.table_data,
  querySql: m.query_sql,
  queryParams: m.query_params,
  abstractIr: m.abstract_ir,
  dataSourceId: m.data_source_id,
  responseType: m.response_type,
  error: m.error,
  suggestions: m.suggestions,
  dataSources: m.data_sources || [],
  agentKey: m.agent_key,
  agentLabel: m.agent_label,
  queries: m.queries,
  additionalResults: m.additional_results,
  sections: m.sections,
  closingText: m.closing_text ?? undefined,
  coverageNotice: m.coverage_notice ?? undefined,
  dataContext: m.data_context,
  mode: m.mode ?? null,
  ratioContext: m.ratio_context,
  followUpQuestions: m.follow_up_questions,
  questionFullyAnswered: m.question_fully_answered,
  multipleChoice: m.multiple_choice,
  scheduledFollowup: m.scheduled_followup ?? undefined,
  actionProposals: m.action_proposals ?? undefined,
  scheduledFollowupResult: m.type === "scheduled_followup_result"
    ? { automation_public_id: m.automation_public_id, original_context: m.original_context, followup_question: m.followup_question }
    : undefined,
  status: m.status ?? null,
});
